module.exports = __webpack_public_path__ + "img/img54.d0fb47b1.svg";